<script>
  import { format } from 'svelte-i18n';
  import { Col, Label, Row } from '@sveltestrap/sveltestrap';

  import Color from '@client/pages/bizcards/studio/designer/editors/color.svelte';
  import { SearchInput } from '@client/pages/brandkit/components';

  import { fields as availableFields } from '@client/stores/fields';
  import { fields, reassignedFields, selectedUser } from '@client/stores/virtual-background';

  import AssignedField from './assigned-field.svelte';

  export let active = false;
  export let foreground = '#FFFFFF';
  export let onDragStart = () => {};

  let searchQuery = '';
  let searchInput;

  $: if (active && searchInput) searchInput.focus();

  $: unavailableFields = $availableFields ? $fields.filter((field) => !$availableFields.includes(field)) : [];

  $: unsetFields = $selectedUser ? $availableFields.filter((field) => !$selectedUser[field]) : [];

  $: usedOrAddedFields = (() => {
    const allFieldNames = new Set([...$availableFields, ...$fields, ...Object.keys($reassignedFields)]);

    const available = [];
    const used = [];

    allFieldNames.forEach((name) => {
      const finalState = $reassignedFields[name] || {};
      const fieldObject = { name, default: {}, ...finalState };

      const isInTemplate = $fields.includes(name);
      const isReassigned = !!$reassignedFields[name];
      const isHidden = finalState.hidden === true;

      // Field is "used" if it's in the template or has a manual override, and isn't hidden.
      if (!isHidden && (isInTemplate || isReassigned)) {
        used.push(fieldObject);
      } else {
        available.push(fieldObject);
      }
    });

    const sortByName = (a, b) => a.name.localeCompare(b.name);

    return [...used, ...available].sort(sortByName);
  })();

  $: filteredUsedFields = usedOrAddedFields.filter((field) =>
    field.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
</script>

<header class="bg-white sticky-top">
  <Row class="w-100 align-items-center border-bottom p-3">
    <Label class="m-0" xs={4}>
      {$format('label.BRAND_TEXT_COLOR')}
    </Label>
    <Col xs={8}>
      <Color bind:value={foreground} />
    </Col>
  </Row>

  {#if $availableFields?.length}
    <div class="p-3 pb-2">
      <SearchInput bind:value={searchQuery} bind:inner={searchInput} />
    </div>
  {/if}
</header>

<div class="p-3 pt-1">
  {#each filteredUsedFields as field}
    <div
      role="listitem"
      draggable="true"
      on:dragstart={(e) => {
        const defaultValue = $reassignedFields[field.name];
        const value = defaultValue
          ? `{{${field.name} | default: ${defaultValue.default.field || `"${defaultValue.default.value}"`}}}`
          : `{{${field.name}}}`;

        onDragStart(e, value);
      }}
    >
      <AssignedField
        {field}
        modified={!!$reassignedFields[field.name]}
        unavailable={unavailableFields.includes(field.name)}
        unset={unsetFields.includes(field.name)}
      />
    </div>
  {/each}
</div>

<style>
  [role='listitem'] {
    cursor: grab;
    user-select: none;
  }
</style>
